export enum ExchangeAuthorizationReasonEnum {
  WRONG_PRODUCT = 'wrong_product',
  UNEXPECTED_PRODUCT = 'unexpected_product',
  MISSING_PRODUCT = 'missing_product',
  DAMAGED_PRODUCT = 'damaged_product',
  PRODUCT_DOESNT_FIT = 'product_doesnt_fit',
}
